export default __webpack_public_path__ + "static/media/telegram.1f561043.jpg";